import { isSet } from '../utils/isSet';

class CoffeeCard {
    constructor(root) {
        this.root = root;
        this.faceElm = root.querySelector('.card__face[aria-labelledby]');
        this.triggerElms = root.querySelectorAll('[aria-controls]');

        this.init();
    }

    init(){
        this.isOpen = false;

        this.onTriggerClickBound = this.onSwitchClick.bind(this);

        this.triggerElms.forEach((triggerElm) => {
            triggerElm.addEventListener( 'click', this.onTriggerClickBound, true);
        });

        this.root.classList.add('has-initialised');
    }


    onSwitchClick(e){
        if (this.isOpen) {
            this.closeCard(e);
        } else {
            this.openCard(e);
        }

        e.stopPropagation();
        e.preventDefault();
    }

    closeCard(e){
        if(!this.isOpen) return;

        const root = this.root;
        const faceElm = this.faceElm;

        this.root.classList.remove('is-open');
        let animationCount = 0;
        this.root.classList.add('is-animating', 'is-animating--closing');

        function animationEndHandler(e){
            if( e.target === root || root.contains(e.target) ){
                animationCount--;

                if (animationCount === 0){
                    root.classList.remove('is-animating', 'is-animating--closing');
                    faceElm.setAttribute('aria-hidden', 'true');
                    document.removeEventListener('animationend', animationEndHandler);
                    document.removeEventListener('animationstart', animationStartHandler);
                }
            }
        }

        function animationStartHandler(e) {
            if( e.target === root || root.contains(e.target) ){
                animationCount++;
            }
        }

        document.addEventListener('animationstart', animationStartHandler);
        document.addEventListener('animationend', animationEndHandler);

        this.isOpen = false;
    }

    openCard(e){
        if(this.isOpen) return;

        const root = this.root;

        this.faceElm.setAttribute('aria-hidden', 'false');
        this.root.classList.add('is-open');

        let animationCount = 0;
        this.root.classList.add('is-animating', 'is-animating--opening');

        function animationEndHandler(e){
            if( e.target === root || root.contains(e.target) ){
                animationCount--;

                if (animationCount === 0){
                    root.classList.remove('is-animating', 'is-animating--opening');
                    document.removeEventListener('animationend', animationEndHandler);
                    document.removeEventListener('animationstart', animationStartHandler);
                }
            }
        }

        function animationStartHandler(e) {
            if( e.target === root || root.contains(e.target) ){
                animationCount++;
            }
        }

        document.addEventListener('animationstart', animationStartHandler);
        document.addEventListener('animationend', animationEndHandler);

        this.isOpen = true;
    }
}

export { CoffeeCard }
